import { useCurrentRole } from 'hooks/useCurrentRole/useCurrentRole';
import { UserRole } from 'interfaces';
import { useAppSelector } from 'redux/hooks';
import { notificationsSelectors } from 'redux/modules/Notifications';

export const useShouldShowNotificationBubble = () => {
  const role = useCurrentRole()?.code;
  const counts = useAppSelector(
    notificationsSelectors.getNewNotificationCounts,
  );

  if (!role || !counts) {
    return false;
  }

  if (role === UserRole.User && counts.statusChanged > 0) {
    return true;
  }

  if (
    (role === UserRole.Mod ||
      role === UserRole.Super ||
      role === UserRole.Admin) &&
    (counts.assignedToYou > 0 || counts.assignedToAnother > 0)
  ) {
    return true;
  }

  return false;
};
